<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <span>
        <a-icon type="wallet" class="margin-right-small" />
        Master Electronic Petty Cash User
      </span>
      <a-button-group ghost>
        <a-button v-if="isKeuangan" icon="plus" type="primary" @click="handleCreate">
          <span>Create</span>
        </a-button>
      </a-button-group>
    </div>
    <div class="wrapper-body">
      <a-card>
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
            <a-input-search v-model="searchParam.search" :onchange="moreSearch" placeholder="Quick Search" />
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
            <a-button :class="getScreen ? 'margin-top' : ''" block
              :icon="advancedsearch == 'display:none' ? 'down' : 'up'" @click="handleshowMore">{{
                advancedsearch == "display:none" ? "More" : "Less"
              }}</a-button>
          </a-col>
        </a-row>
        <a-row :style="advancedsearch" :gutter="16" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Type</label>
              <a-select placeholder="All Type" v-model="searchParam.type_kkl" class="width-full" initialValue="all"
                :filterOption="filterOption" showSearch allowClear>
                <a-select-option v-for="item in typeList" :key="item" :value="item">{{ item
                }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <div class="m-form-item-wrapper">
              <label>Bank</label>
              <a-select placeholder="All Bank" v-model="searchParam.bank" class="width-full" initialValue="all"
                :filterOption="filterOption" showSearch allowClear>
                <a-select-option v-for="item in getBank" :key="item.name" :value="item.name">{{ item.name
                }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <div class="m-form-item-wrapper">
              <label>Report Date</label>
              <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="searchParam.penyerahan_dt"
                :format="getDefaultDateFormat" allowClear />
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Status</label>
              <a-select showSearch v-model="searchParam.aktif_sts" placeholder="All Status" class="width-full" initialValue="all"
                allowClear :filterOption="filterOption">
                <a-select-option value="1">Active</a-select-option>
                <a-select-option value="0">Non Active</a-select-option>
              </a-select>
            </div>
          </a-col>
        </a-row>
      </a-card>
      <div class="bordered">
        <a-table rowKey="id_user_kkl" key="userKkltable" size="small" bordered :scroll="{ x: 1300 }" :columns="columns"
          :dataSource="tempDataUserKkl" :loading="loading">
          <template slot="nomor" slot-scope="text, data, index">
            <span>{{ index + 1 }}</span>
          </template>
          <template slot="limit_kredit" slot-scope="text, data">
            <CurrencyJustified :currencyValue="'IDR'" :valueNumber="(data.limit_kredit ? data.limit_kredit : 0)" />
          </template>
          <template slot="penyerahan_dt" slot-scope="item">
            {{ item.penyerahan_dt ? moment(item.penyerahan_dt).format("DD-MM-YYYY") : ''}}
          </template>
          <template slot="aktif_sts" slot-scope="item">
            <a-tag :color="item.aktif_sts=='1'?'green':'red'">{{item.aktif_sts=='1'?'ACTIVE':'NON ACTIVE'}}</a-tag>
          </template>
          <template slot="act" slot-scope="text, data">
            <a-button-group>
              <a-tooltip class="m-tooltip-inner" placement="bottomLeft">
                <template slot="title">
                  <span>Edit</span>
                </template>
                <a-button type="secondary" @click="handleEdit(data)" :disabled="data.aktif_sts != '1'" icon="edit">
                </a-button> 
              </a-tooltip>
              <a-tooltip class="m-tooltip-inner" placement="bottomLeft">
                <template slot="title">
                  <span>Set Non Active</span>
                </template>
                <a-button :disabled="data.aktif_sts != '1'" type="danger" icon="stop" @click="handleDeaktifasi(data)">
                </a-button>
              </a-tooltip>
            </a-button-group>
          </template>
        </a-table>
      </div>
    </div>

    <a-modal v-if="modalCreate" v-model="modalCreate" :title="modalMode=='Create'?'Create Electronic Petty Cash User':'Edit Electronic Petty Cash User'" :width="600" centered
      :maskClosable="false" @ok="handleOk" @cancel="handleClose" okText="OK" cancelText="Cancel" :confirmLoading="loading">
      <a-form-model ref="kklform" :model="form" :rules="rules">
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-model-item ref="type_kkl" label="Type" prop="type_kkl">
              <a-select placeholder="Select Type" v-model="form.type_kkl" class="width-full" :filterOption="filterOption"
                showSearch allowClear>
                <a-select-option value="M-Banking">{{ 'M-Banking' }}</a-select-option>
                <a-select-option value="Kartu">{{ 'Kartu' }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item ref="bank" label="Bank" prop="bank">
              <a-auto-complete
                v-model="form.bank"
                :dropdownMatchSelectWidth="false"
                optionLabelProp="value"
                @search="handleSearchSuggest"
              >
              <template slot="dataSource">
                <a-select-option v-for="(items,index) in resultSuggestBank" :key="index" :value="items.name">
                  {{ items.name }}
                </a-select-option>
              </template>
              </a-auto-complete>
            </a-form-model-item>
            <a-form-model-item ref="tlc_user" label="User" prop="tlc_user">
              <a-select placeholder="Select User" v-model="form.tlc_user" class="width-full" :filterOption="filterOption"
                showSearch allowClear>
                <a-select-option
                  v-for="karyawan in getAllKaryawan"
                  :key="karyawan.tlc"
                >{{karyawan.tlc}} - {{karyawan.nama}}</a-select-option> 
              </a-select>
            </a-form-model-item>
            <a-form-model-item ref="user_admin" label="User Admin" prop="user_admin">
              <a-select placeholder="Select User Admin" v-model="form.user_admin" class="width-full" :filterOption="filterOption"
                showSearch allowClear>
                <a-select-option
                  v-for="karyawan in getAllKaryawan"
                  :key="karyawan.tlc"
                >{{karyawan.tlc}} - {{karyawan.nama}}</a-select-option> 
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-model-item ref="id_kkl" label="Account Number" prop="id_kkl">
              <a-input v-model="form.id_kkl"/>
            </a-form-model-item>
            <a-form-model-item v-if="isTypeKartu" ref="no_kartu" label="Card Number" prop="no_kartu">
              <a-input v-model="form.no_kartu"/>
            </a-form-model-item>
            <a-form-model-item ref="limit_kredit" label="Limit Kredit (IDR)" prop="limit_kredit">
              <a-input-number :min="0" class="m-width-full m-text-align right" @keydown="onlyNumber" :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-model="form.limit_kredit"></a-input-number>
            </a-form-model-item>
            <a-form-model-item ref="penyerahan_dt" label="Report Date" prop="penyerahan_dt">
              <a-date-picker v-model="form.penyerahan_dt" format="DD-MM-YYYY" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <template slot="footer">
          <a-button key="back" @click="handleClose"> Cancel </a-button>
        </template>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "User-kkl-index",
  mixins: [CurrencyFormat, HandleRoute, shortingArray, GlobalMethod],
  data() {
    return {
      tempDataUserKkl: [],
      dataUserkkl: [],
      loading: false,
      advancedsearch: "display:none",
      modalCreate: false,
      form: {
        tlc_user: null,
        type_kkl: null,
        bank: null,
        id_kkl: null,
        no_kartu: null,
        limit_kredit: null,
        penyerahan_dt: moment(),
        user_admin: null
      },
      typeList: ['M-Banking', 'Kartu'],
      bankList:[],
      searchParam: {
        search: undefined,
        type_kkl: null,
        bank: null,
        aktif_sts: null,
        penyerahan_dt: [],
      },
      modalMode: 'Create',
      resultSuggestBank: []
    };
  },
  mounted() {
    this.handleReload();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getBank",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAllKaryawan",
    ]),
    moreSearch: function () {
      let tempfilter = this.dataUserKkl;
      if (this.dataUserKkl && this.dataUserKkl.length > 0) {
        if (this.searchParam.search) {
          tempfilter = tempfilter.filter(
            (obj) =>
            (obj.allstring &&
              obj.allstring
                .toLowerCase()
                .indexOf(this.searchParam.search.toLowerCase()) >= 0)
          );
        }
        if (this.searchParam.type_kkl) {
          tempfilter = tempfilter.filter(
            (obj) =>
              obj.type_kkl && obj.type_kkl.toLowerCase() == this.searchParam.type_kkl.toLowerCase()
          );
        }
        if (this.searchParam.bank) {
          tempfilter = tempfilter.filter(
            (obj) =>
              obj.bank && obj.bank.toLowerCase() == this.searchParam.bank.toLowerCase()
          );
        }
        if (this.searchParam.aktif_sts) {
          tempfilter = tempfilter.filter(
            (obj) =>
            (obj.aktif_sts &&
              Number(obj.aktif_sts)==Number(this.searchParam.aktif_sts))
          );
        }
        if (this.searchParam.penyerahan_dt && this.searchParam.penyerahan_dt.length > 0) {
          let startDt = moment(this.searchParam.penyerahan_dt[0]).format("DD-MM-YYYY");
          let endDt = moment(this.searchParam.penyerahan_dt[1]).format("DD-MM-YYYY");
          tempfilter = tempfilter.filter(
            (obj) =>
              obj.penyerahan_dt &&
              moment(moment(obj.penyerahan_dt, "YYYY-MM-DD").toDate()).format("DD-MM-YYYY") >= startDt &&
              moment(moment(obj.penyerahan_dt, "YYYY-MM-DD").toDate()).format("DD-MM-YYYY") <= endDt
          );

        }
      }

      if (
        (!this.searchParam.search || this.searchParam.search == "") &&
        !this.searchParam.type_kkl &&
        !this.searchParam.bank &&
        !this.searchParam.aktif_sts &&
        (!this.searchParam.penyerahan_dt || this.searchParam.penyerahan_dt.length == 0)
      ) {
        tempfilter = this.dataUserKkl;
      }

      this.tempDataUserKkl = tempfilter;
      return true;
    },
    isKeuangan(){
      let data = _.filter(this.getAuth.nama_bidang,(obj) => obj=="Keuangan");
      return data.length>0 ? true : false;
    },
    columns(){
      let columns = [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          align: "right",
          width: 50,
        },
        {
          title: "TLC",
          key: "tlc_user",
          dataIndex: "tlc_user",
          align: "center",
          width: 75,
        },
        {
          title: "Tipe",
          key: "type_kkl",
          dataIndex: "type_kkl",
          width: 300,
        },
        {
          title: "Bank",
          key: "bank",
          width: 200,
          dataIndex: "bank",
        },
        {
          title: "Account Number",
          key: "id_kkl",
          dataIndex: "id_kkl",
          width: 250,
        },
        {
          title: "Card Number",
          key: "no_kartu",
          dataIndex: "no_kartu",
          width: 250,
        },
        {
          title: "Limit",
          key: "limit_kredit",
          scopedSlots: { customRender: "limit_kredit" },
          width: 200,
        },
        {
          title: "Report Date",
          key: "penyerahan_dt",
          scopedSlots: { customRender: "penyerahan_dt" },
          align: "center",
          width: 150,
        },
        {
          title: "Status",
          key: "aktif_sts",
          width: 150,
          scopedSlots: { customRender: "aktif_sts" },
          align: "center",
        },
        {
          title: "User Admin",
          key: "user_admin",
          dataIndex: "user_admin",
          align: "center",
          width: 75,
        },
      ];

      if(this.isKeuangan){
        columns.push({
          title: "Action",
          fixed: "right",
          key: "act",
          scopedSlots: { customRender: "act" },
          width: 100,
          align: "center",
          },
        )
      }
      return columns
    },
    isTypeKartu(){
      return this.form.type_kkl == "Kartu"
    },
    rules(){
      return {
        type_kkl: [
          {
            required: true,
            message: "Type is required!",
            trigger: "change",
          },
        ],
        bank: [
          {
            required: true,
            message: "Bank is required!",
            trigger: "change",
          },
        ],
        id_kkl: [
          {
            required: true,
            message: "Account number is required!",
            trigger: "change",
          },
        ],
        no_kartu: [
          {
            required: this.isTypeKartu,
            message: "Card number is required!",
            trigger: "change",
          },
        ],
        tlc_user: [
          {
            required: true,
            message: "User is required!",
            trigger: "change",
          },
        ],
        limit_kredit: [
          {
            required: true,
            message: "Limit Credit is required!",
            trigger: "change",
          },
        ],
        penyerahan_dt: [
          {
            required: true,
            message: "Report Date is required!",
            trigger: "change",
          },
        ],
      }
    }
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filterOptionNoGuarantee(input, option) {
      return (
        option.componentOptions.children[0].elm.innerText
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.searchParam.search = undefined;
      this.searchParam.type_kkl = null;
      this.searchParam.bank = null;
      this.searchParam.aktif_sts = null;
    },
    async handleReload() {
      this.loading = true;
      await this.$store.dispatch("getUserKklList", { auth: this.getAuth }).then((res) => {
        this.dataUserKkl = res.data.data;
        this.dataUserKkl.forEach((element, index) => {
          this.dataUserKkl[index].allstring = (element.tlc_user ? element.tlc_user : "")
            + (element.type_kkl ? element.type_kkl : "")
            + (element.bank ? element.bank : "")
            + (element.id_kkl ? element.id_kkl : "")
            + (element.limit_kredit ? this.formatRupiah(element.limit_kredit) : "")
            + (element.penyerahan_dt ? moment(element.penyerahan_dt).format('DD-MM-YYYY') : "")
            + (element.aktif_sts ? (element.aktif_sts=="1"?'ACTIVE':'NON ACTIVE') : "")
        });

        this.tempDataUserKkl = this.dataUserKkl;
        this.loading = false;
      });
      this.resetSearch();
    },
    resetform() {
      this.form = {
        type_kkl: null,
        bank: null,
        id_kkl: null,
        limit_kredit: null,
        tlc_user: null,
        penyerahan_dt: moment(),
      };
      this.modalMode = "Create"
      this.modalIdValue = ""
    },
    handleCreate() {
      this.resetform();
      this.modalMode = "Create"
      this.modalIdValue = ""
      this.modalCreate = true;
    },
    handleEdit(item) {
      this.modalIdValue = item.id_user_kkl
      this.form.type_kkl= item.type_kkl
      this.form.bank= item.bank
      this.form.id_kkl= item.id_kkl
      this.form.no_kartu= item.no_kartu
      this.form.tlc_user= item.tlc_user
      this.form.limit_kredit= item.limit_kredit
      this.form.penyerahan_dt= item.penyerahan_dt?moment(item.penyerahan_dt):null
      this.form.user_admin = item.user_admin

      this.modalMode= 'Edit';
      this.modalCreate = true;
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    handleViewFile(item) {
      window.open(this.$serviceUrl + item.file_url);
    },
    handleRemoveList() {
      this.form.file = undefined;
    },
    beforeUpload(file) {
      this.form.file = [file];
      return false;
    },
    handleClose() {
      this.$refs.file = null;
      this.modalCreate = false;
    },
    handleOk() {
      this.$refs.kklform.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        this.loading = true;
        let formData = null

        if(this.modalMode=='Create'){
          formData = new FormData();
          formData.append("type_kkl", this.form.type_kkl);
          formData.append("bank", this.form.bank);
          formData.append("id_kkl", this.form.id_kkl);
          if (this.isTypeKartu && this.form.no_kartu)
            formData.append("no_kartu", this.form.no_kartu);
          formData.append("tlc_user", this.form.tlc_user);
          formData.append("limit_kredit", this.form.limit_kredit);
          formData.append("penyerahan_dt", moment(this.form.penyerahan_dt).format('YYYY-MM-DD'));
          if (this.form.user_admin)
            formData.append("user_admin", this.form.user_admin);
        }else{
          formData = {
            type_kkl: this.form.type_kkl,
            bank: this.form.bank,
            id_kkl: this.form.id_kkl,
            tlc_user: this.form.tlc_user,
            limit_kredit: this.form.limit_kredit,
            penyerahan_dt: moment(this.form.penyerahan_dt).format('YYYY-MM-DD'),
            id_user_kkl: this.modalIdValue
          }
          if (this.isTypeKartu && this.form.no_kartu)
            formData.no_kartu = this.form.no_kartu
          if (this.form.user_admin)
            formData.user_admin = this.form.user_admin
        }

        this.$store.dispatch(this.modalMode=="Create" ? "createUserKkl" : "editUserKkl", {
          auth: this.getAuth,
          params: formData
        })
          .then((res) => {
            if (res.data.status == true) {
              this.displayMessageValue("success-other", res.data.message);
              this.$nextTick(() => {
                this.form.file = undefined;
              });
              this.handleReload();
            } else {
              this.displayMessageValue(
                "error-other",
                res.data.message
              );
            }
            this.loading = false;
            this.modalCreate = false;
          })
          .catch(err => {
            let responses = Object.assign({}, err.response.data);
            if (responses.message && responses.status == false) {
              this.displayMessageValue("error-other", responses.message);
            } else {
              this.displayMessageValue("error", responses);
            }
            this.loading = false;
          });
      });
    },
    handleDeaktifasi(item) {
      const that = this;
      this.$confirm({
        title: "Are you sure to set non active this data?",
        content: "",
        okText:"Yes",
        cancelText:"No",
        onOk() {
          let params = item.id_user_kkl
          that.$store.dispatch("nonActiveKkl", { auth: that.getAuth, params })
          .then((res) => {
            if(res.data.status==true){
              that.displayMessageValue("success-other", res.data.message);
              that.handleReload();
            }else{
              that.displayMessageValue(
                "error-other",
                res.data.message
              );
            }
            that.loading = false;
          })
          .catch(err => {
            console.log(err);
              that.loading = false;
          });
        },
          onCancel() {},
        });
    },
    handleSearchSuggest(value){
      let result;
      if (!value) {
        result = [];
      } else if(value.length>=2){
        result = this.getBank.filter((item)=>{return item.name.toLowerCase().indexOf(value.toLowerCase())>=0})
      }
      this.resultSuggestBank = result;
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);

  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }

  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }

    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead>tr>th {
  text-align: center;
}
</style>
